<script setup>
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import MetricCard from 'dashboard/components-next/captain/pageComponents/overview/MetricCard.vue';
import RangeSelector from 'dashboard/components-next/captain/pageComponents/overview/RangeSelector.vue';

import AgentNotice from './AgentNotice.vue';
import AgentSection from './AgentSection.vue';

defineProps({
  title: { type: String, required: true },
  metrics: { type: Array, default: () => [] },
  isLoading: { type: Boolean, default: false },
  error: { type: String, default: '' },
  loadingLabel: { type: String, required: true },
  errorTitle: { type: String, required: true },
  retryLabel: { type: String, required: true },
  canDrilldown: { type: Boolean, default: false },
});

const emit = defineEmits(['retry', 'openMetric']);
const selectedRange = defineModel('selectedRange', {
  type: String,
  default: 'this_month',
});
</script>

<template>
  <AgentSection :title="title">
    <template #titleAction>
      <RangeSelector v-model="selectedRange" />
    </template>

    <div
      v-if="isLoading"
      class="flex min-h-36 items-center justify-center gap-3 text-sm text-n-slate-11"
      role="status"
      aria-live="polite"
    >
      <Spinner />
      <span>{{ loadingLabel }}</span>
    </div>

    <AgentNotice
      v-else-if="error"
      :title="errorTitle"
      :description="error"
      tone="error"
      action-icon="i-lucide-refresh-cw"
      :action-label="retryLabel"
      @action="emit('retry')"
    />

    <div
      v-else
      class="grid grid-cols-1 gap-px overflow-hidden rounded-xl border border-n-weak bg-n-weak sm:grid-cols-2 lg:grid-cols-3"
    >
      <MetricCard
        v-for="metric in metrics"
        :key="metric.key"
        :label="metric.label"
        :value="metric.value"
        :trend="metric.trend"
        :hint="metric.hint"
        :trend-good="metric.trendGood"
        :clickable="canDrilldown && Boolean(metric.metric)"
        @click="emit('openMetric', metric)"
      />
    </div>
  </AgentSection>
</template>
